module.exports = __webpack_public_path__ + "media/images/payments/bancontact-f34ac49459d6f2b046571faeadac7003.svg";